module.exports = __webpack_public_path__ + "media/images/map-marker-2bd7904122f8bf4d9e4ef055b894f9c5.png";